import { render, staticRenderFns } from "./StatsPageComponent.vue?vue&type=template&id=3bfa1e73"
import script from "./StatsPageComponent.vue?vue&type=script&lang=js"
export * from "./StatsPageComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports